import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { isIOSiPhoneDevice } from 'src/utils/util';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const QuickOrderContainer = styled.div`
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 29px;
    display: flex;
    overflow-y: ${({ overFlowY }) => overFlowY};
    ${media.mobileDevice`
    flex-wrap: wrap;
    flex-direction: row;
    padding: ${({ padding }) =>
        padding ? padding : '0px'};
    align-items: center;
    justify-content: space-between;
    `};
`;
export const QuickOrderHeaderContainer = styled.div`
    /* display: flex;
    width: 100%;
    ${media.mobileDevice`
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    `} */
    display: grid;
    width: 100%;
    height: 3rem;
    grid-template-columns: [col-1-start] 21% [col-1-end col-2-start] auto [col-2-end col-3-start] 25% [col-3-end];
    grid-template-rows: [row-1-start] auto [row-1-end row-2-start] auto [row-2-end];

    ${media.mediumDevice`    
         grid-template-columns: [col-1-start] 28% [col-1-end col-2-start] auto [col-2-end col-3-start] 22% [col-3-end];
    `};
    ${media.smalDevice`    
         grid-template-columns: [col-1-start] 30% [col-1-end col-2-start] auto [col-2-end col-3-start] 22% [col-3-end];
    `};
    ${media.mobileDevice`
      height: 4.7rem;
      grid-template-rows: [row-1-start] 50% [row-1-end row-2-start] 50% [row-2-end];
      margin-top: -16px;
    `}
`;

export const QuickOrderHeaderSubContainer = styled.div`
    display: block;
    width: 100%;
    ${media.mobileDevice`
    display: flex;
    justify-content: space-between;
    `}
`;
export const Heading = styled.div`
    grid-row: row-1-start/row-1-end;
    grid-column: ${({ letterSpacing }) =>
        letterSpacing ? 'col-1-start/col-1-end' : 'col-3-start/col-3-end'};
    justify-self: ${({ changeColor }) => (changeColor ? 'end' : '')};
    align-self: center;
    margin-right: ${({ changeColor }) => (changeColor ? '10px' : '')};

    font-family: AvenirNextWorld Demi;
    text-align: left;
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? '0px' : '-0.12px'};
    color: ${({ changeColor }) => (changeColor ? '#1010EB' : '#202124')};
    font-size: ${({ changeColor }) => (changeColor ? '15px' : '14px')};
    opacity: 1;
    align-items: center;
    cursor: ${({ cursor }) => cursor};
    ${media.mobileDevice`
    align-self: start;
      grid-column: ${({ letterSpacing }) =>
          letterSpacing ? 'col-1-start/col-2-end' : 'col-3-start/col-3-end'};
     margin-right:  ${({ changeColor }) => (changeColor ? '0px' : '')};      
    `}
`;

export const AutoCompleteContainer = styled.div`
    grid-row: row-1-start/row-1-end;
    grid-column: col-2-start/col-2-end;
    align-self: center;
    ${media.mobileDevice`  grid-row: row-2-start/row-2-end;
        grid-column: col-1-start/col-3-end;`}/* order: 2;
    margin: 0;
    padding: 0;
    width: 50%;
    ${media.mobileDevice`
    width: 100%;
        margin-top: 12.5px;
    `} */
`;

export const GridHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 16px 0px 0px 0px;
    padding: 15px 19px;
    width: 99%;
    height: 48px;
    justify-content: center;
    background: #ffffff 0% 0% no-repeat padding-box;
    //box-shadow: 0px 0px 6px #00000029;
    //border-radius: 6px;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    ${media.mediumDevice`
        width:100%;
    `}
    ${media.smalDevice`
        width:100%;
    `}
    ${media.mobileDevice`     
        width:100%;
    `}
`;

export const RowContainer = styled.div`
    font-family: AvenirNextWorld Demi;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: #3c3c3c;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '')};
`;

export const QtyAndDeleteContainer = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 13px;
    margin-top: 1px;
    margin-right: 2px;
    .qty {
        padding-right: 97px;
        ${media.mobileDevice`
         padding-right: 38px;
    `}
    }
`;

export const DeleteContainer = styled.div`
    height: 12px;
    width: 15px;
    padding-top: 3px;
    cursor: pointer;
`;

export const SetNameAndDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-family: AvenirNextWorld Regular;
    letter-spacing: 0px;
    opacity: 1;
    font-size: 12px;
    .title {
        font-size: 16px;
        color: #202124;
        text-transform: uppercase;
    }
    .details {
        color: #140f4b;
        opacity: 0.7;
    }
    .error {
        color: #ed002a;
    }
`;

export const SetCountAndDeleteContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 50%;
    justify-content: flex-end;
    .inputBox {
        height: 40px;
        width: 86px;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: ${({ error }) =>
            error ? '1px solid #ED002A66' : '2px solid #ebeded'};
        border-radius: 6px;
        opacity: 1;
        text-align: center;
        &:focus {
            outline: none;
        }
        ${media.mobileDevice`
         width: 61px;
    `}
    }
    .qty {
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding-right: 58px;
        ${media.mobileDevice`
         padding-right: 12px;
    `}
    }
    .delete {
        padding-top: 8px;
    }
    .validation {
        font-family: AvenirNextWorld Regular;
        font-size: 12px;
        color: #ed002a;
        opacity: 0.7;
        margin: 0px;
        margin-bottom: -19px;
        margin-top: 4px;
    }
`;

export const HeaderContainer = styled.div`
    color: #130e4a;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 18px;
    ${media.mobileDevice`    

    `};
`;

export const Title = styled.div``;
export const Icon = styled.div`
    border: 1px solid #ffffff;
    opacity: 1;
    background: transparent url(${({ mobilePath }) => mobilePath}) 0% 0%
        no-repeat padding-box;
    width: 22px;
    height: 23px;
    ${media.mobileDevice`
    
    `}
`;

export const TextAreaContainer = styled.div`
    margin: 0px 20px 0px 20px;
    ${media.mobileDevice`
     margin: 0px;
    `}
`;

export const TextArea = styled.textarea`
    resize: none;
    width: 100%;
    height: ${({ height }) => (height ? height : '330px')};
    margin-top: 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 2px solid #ebeded;
    border-radius: 6px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    font-size: 14px;
    padding: 10px 0 0 10px;
    &::-webkit-input-placeholder {
    }
    &:focus {
        outline: none !important;
    }
    ${media.mobileDevice`
     height: 182px;
    `}
    @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation : landscape) {
        height: ${({ landscapeHeight }) => landscapeHeight};
        margin-left: ${({ landscapeMarginLeft }) => landscapeMarginLeft};
    }
`;

export const PopupContainer = styled.div`
    width: 582px;
    height: ${({ height }) => (height ? height : '452px')};
    overflow-x: hidden;
    ${media.mobileDevice`
    width: 325px;
    height: 290px;
    `}
`;

export const ButtonsContainer = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 30px;
    ${media.mobileDevice`
     justify-content: center;
     margin-top: 30px;
    `}
`;

export const AutocompleteStyles = {
    // marginTop: '12.5px',
    width: '100%',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    borderRadius: '25px',
};

export const AutoCompleteInputFieldStyle = {
    height: '40px',
    width: '100%',
    borderRadius: '25px',
    zIndex: 10,
};

export const AutoCompleteTemplateContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0.5px 0px #0000000d;
    margin: 5px 0 10px 10px;

    ${media.mobileDevice`
       
    `}
`;

export const AutoCompleteDescription = styled.div`
    width: fit-content;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
    opacity: 0.7;
    color: #140f4b;
    ${media.mobileDevice`
        margin: 0px 0 7px 0px;
        box-shadow:none;
    `}
`;

export const AutoCompleteTemplateHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #140f4b;
    .setNumber {
        font-family: 'AvenirNextWorld Demi';
        margin-right: 10px;
        font-size: 14px;
    }
    .brand {
        font-size: 13px;
        font-family: 'AvenirNextWorld Regular';
    }
`;

export const LoadingTextStyles = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 18px;
    letter-spacing: 0px;
    color: ${({ color }) => (color ? '#4F4F4F' : '#ffffff')};
`;

export const SpinningLoaderContainer = styled.div`
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    height: ${({ isMobileView }) =>
        isMobileView ? 'calc(100vh - 221px)' : '85%'};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const OuterDiv = styled.div`
    width: 100%;
    box-shadow: 0px 1px 2px #00000029;
    /* border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc; */
    /* border-radius: 0px 0px 6px 6px; */
    border: 1px solid #dcdcdc;
    opacity: 1;
    height: auto;
    overflow: scroll;
    /*background-color: #ffff; */
    ${media.mobileDevice`
    height: auto;
    `}
`;

export const Div = styled.div`
        height: ${(props) => props.height || 'calc(100vh - 21.5rem)'};
    overflow-y: scroll;
       scrollbar-width:${({ scrollBar }) => scrollBar};// add this props to hide scroll bar 'none'

    width: 100%;
    ${scrollBarStyle}
    ${media.mobileDevice`     
        &::-webkit-scrollbar {
            display: none;
        }
    `}
    ${media.smalDevice`
        &::-webkit-scrollbar {
            display: none;
        }
    `}
    ${media.mediumDevice`
        &::-webkit-scrollbar {
            display: none;
        }
    `}
    /* @media only screen and (max-width: 1024px) and (orientation: landscape) {
        height: calc(100vh - 22rem);
    } */
    @media only screen and (max-width: 1024px) and (orientation: portrait) {
        height: calc(100vh - 21rem);
    }
    @media only screen and (max-width: 768px) and (orientation: portrait) {
        height: calc(100vh - 26rem);
    }
    @media only screen and (max-width: 1024px) and (orientation: landscape) {
        height: calc(100vh - 26.5rem);
    }
    ${media.mobileDevice`
        padding-bottom: 140px;
        &::-webkit-scrollbar {
            display: ${({ theme }) => theme.scrollOption.show};
            width: 5px;
        }
        &::-webkit-scrollbar-track {
            margin-top: 0px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({ theme }) => theme.scrollOption.thumb_color};
            border-radius: ${({ theme }) => theme.scrollOption.border_radius};
            height: 3rem;
        }
        height: ${(props) =>
            isIOSiPhoneDevice() && props.innerHeight > 800
                ? 'calc(100vh - 27.5rem)'
                : props.innerHeight <= 715
                ? 'calc(100vh - 19.30rem)'
                : 'calc(100vh - 9rem)'};
    `}
`;

export const StyledDiv = styled.div`
    width: 100%;
    height: 25px;
    margin: 0 0 0 32px;
    ${media.mobileDevice`
    display:none;
`}
`;
